import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Link, Navigate, useLocation } from 'react-router-dom';
import { auth, db } from './firebase';
import { onAuthStateChanged, signOut } from 'firebase/auth';
import { doc, getDoc, collection, query, where, onSnapshot, orderBy } from 'firebase/firestore';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// ✅ Custom Component Import
import LanguageSelector from './components/LanguageSelector';

// Baaki Imports same rahenge...
import Signup from './pages/Signup';
import AddWorker from './pages/AddWorker';
import EditWorker from './pages/EditWorker';
import FindWorkers from './pages/FindWorkers';
import WorkerDetails from './pages/WorkerDetails';
import Profile from './pages/Profile';
import Contact from './pages/Contact';
import Terms from './pages/Terms';
import About from './pages/About';
import NotFound from './pages/NotFound';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Footer from './components/Footer';
import Preloader from './components/Preloader';
// import Logo from './components/Logo'; // ❌ Iski ab zaroorat nahi hai
import SubscriptionLock from './components/SubscriptionLock';

const Navbar = ({ user, userRole, handleLogout }) => {
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => { setIsOpen(false); }, [location]);

  // 🔥 SIRF ENGINE LOAD KARO (Widget nahi) 🔥
  useEffect(() => {
    if (!document.getElementById('google-translate-script')) {
      const script = document.createElement('script');
      script.id = 'google-translate-script';
      script.src = '//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit';
      document.body.appendChild(script);
      
      // Dummy function taaki error na aaye
      window.googleTranslateElementInit = () => {
         new window.google.translate.TranslateElement({
            pageLanguage: 'en',
            layout: window.google.translate.TranslateElement.InlineLayout.SIMPLE,
            autoDisplay: false,
         }, 'google_translate_hidden_div'); 
      };
    }
  }, []);

  const getLinkClass = (path) => {
    const isActive = location.pathname === path;
    const baseClass = "block px-4 py-3 rounded-xl font-bold text-sm transition-all";
    if (isOpen) return isActive ? `${baseClass} bg-blue-50/80 text-blue-700` : `${baseClass} text-slate-700 hover:bg-slate-50/50`;
    return isActive ? `px-4 py-2 rounded-full font-bold text-sm bg-blue-600 text-white shadow-md` : `px-4 py-2 rounded-full font-bold text-sm text-slate-700 hover:bg-white/40 hover:text-black hover:shadow-sm`;
  };

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-white/70 backdrop-blur-xl shadow-sm border-b border-white/20 py-2 transition-all" style={{ paddingTop: 'env(safe-area-inset-top)' }}>
      {/* Hidden Div (Engine ke liye zaroori hai) */}
      <div id="google_translate_hidden_div" style={{display: 'none'}}></div>

      <div className="max-w-7xl mx-auto px-4">
        <div className="flex justify-between items-center">
          
          {/* ✅ UPDATED LOGO: KaamSetu Directly Here */}
          <Link to="/" className="z-50 group flex items-center gap-2">
             <div className="w-10 h-10 rounded-full bg-blue-600 flex items-center justify-center text-white text-xl font-bold border-2 border-white shadow-md">
               🤝
             </div>
             <div>
               <h1 className="text-xl font-black text-slate-800 tracking-tighter leading-none">
                 Kaam<span className="text-yellow-500">Setu</span>
               </h1>
               <p className="text-[8px] text-slate-500 font-bold tracking-widest uppercase">काम और भरोसे का सेतु 🇮🇳</p>
             </div>
          </Link>

          <div className="flex items-center gap-3">
            
            {/* ✅ DESKTOP: Apna Custom Dropdown */}
            <div className="hidden md:block w-40">
                <LanguageSelector />
            </div>

            <div className="hidden md:flex items-center gap-1">
              <Link to="/" className={getLinkClass('/')}>🔍 Find Workers</Link>
              <Link to="/contact" className={getLinkClass('/contact')}>📞 Support</Link>
              {user ? (
                <>
                  {userRole === 'worker' && <Link to="/add-worker" className="px-4 py-2 rounded-full font-bold text-sm bg-yellow-300 text-black shadow-md">🛠️ Work Profile</Link>}
                  <Link to="/profile" className={getLinkClass('/profile')}>👤 Profile</Link>
                  <button onClick={handleLogout} className="ml-2 w-8 h-8 rounded-full bg-red-100 text-red-600 font-bold">✕</button>
                </>
              ) : (
                <Link to="/signup" className="px-6 py-2 rounded-full font-bold text-sm bg-yellow-400 text-black shadow-lg">Login / Register</Link>
              )}
            </div>

            {/* Mobile Toggle */}
            {user ? <Link to="/profile" className="md:hidden flex items-center justify-center w-10 h-10 rounded-full bg-slate-100">👤</Link> : <Link to="/signup" className="md:hidden px-4 py-2 rounded-full text-xs font-bold bg-yellow-400 text-black">Login</Link>}
            <button onClick={() => setIsOpen(!isOpen)} className="md:hidden p-2 text-2xl z-50 text-slate-800">{isOpen ? '✕' : '☰'}</button>
          </div>
        </div>

        {/* Mobile Menu */}
        {isOpen && (
          <div className="md:hidden absolute top-full left-0 right-0 bg-white/95 backdrop-blur-2xl shadow-2xl p-4 flex flex-col gap-2 rounded-b-3xl">
            
            {/* ✅ MOBILE: Apna Custom Dropdown */}
            <div className="flex flex-col items-center justify-center mb-4 pb-4 border-b border-slate-200">
                <span className="text-[10px] font-bold text-slate-400 mb-2 tracking-widest">SELECT LANGUAGE</span>
                <div className="w-full px-4">
                    <LanguageSelector />
                </div>
            </div>

            <Link to="/" className={getLinkClass('/')}>🔍 Find Workers</Link>
            <Link to="/contact" className={getLinkClass('/contact')}>📞 Customer Care</Link>
            {user ? (
                <>
                    <Link to="/profile" className={getLinkClass('/profile')}>👤 My Profile</Link>
                    <button onClick={handleLogout} className="w-full text-left px-4 py-3 text-red-600 font-bold text-sm">🚪 Logout</button>
                </>
            ) : <Link to="/signup" className="block w-full text-center px-4 py-3 rounded-xl font-bold text-sm bg-yellow-400 text-black">🔑 Login</Link>}
          </div>
        )}
      </div>
    </nav>
  );
};

// --- MAIN APP ---
function App() {
  const [user, setUser] = useState(null);
  const [userRole, setUserRole] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isLocked, setIsLocked] = useState(false);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
      if (currentUser) {
        setUser(currentUser);
        const docRef = doc(db, "users", currentUser.uid);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) setUserRole(docSnap.data().role);
        try {
          const configDoc = await getDoc(doc(db, "app_settings", "config"));
          if (configDoc.exists() && configDoc.data().billing_start_date) {
            if (Math.ceil(Math.abs(new Date() - new Date(configDoc.data().billing_start_date)) / (86400000)) > 60) setIsLocked(true);
          }
        } catch (e) {}
      } else { setUser(null); setUserRole(null); }
      setLoading(false);
    });
    return unsubscribe;
  }, []);

  useEffect(() => {
    if (user) {
      const q = query(collection(db, "notifications"), where("toUserId", "==", user.uid), where("read", "==", false), orderBy("timestamp", "desc"));
      const unsubscribe = onSnapshot(q, (snapshot) => {
        snapshot.docChanges().forEach((change) => {
          if (change.type === "added") {
            const notif = change.doc.data();
            new Audio("https://actions.google.com/sounds/v1/alarms/beep_short.ogg").play().catch(e=>{});
            toast.info(<div><p className="font-bold">🔔 {notif.message}</p></div>, { position: "top-right", autoClose: 6000 });
          }
        });
      });
      return () => unsubscribe();
    }
  }, [user]);

  const handleLogout = async () => { await signOut(auth); setUser(null); setIsLocked(false); };
  if (loading) return <Preloader />;

  return (
    <BrowserRouter>
      <Navbar user={user} userRole={userRole} handleLogout={handleLogout} />
      <ToastContainer style={{ zIndex: 99999 }} />
      {isLocked && userRole !== 'admin' && <SubscriptionLock />}
      <div className={`min-h-screen bg-slate-50 flex flex-col ${isLocked && userRole !== 'admin' ? 'overflow-hidden h-screen blur-sm pointer-events-none' : ''}`}>
        <div className="flex-grow">
          <Routes>
            <Route path="/" element={<FindWorkers />} />
            <Route path="/signup" element={!user ? <Signup /> : <Navigate to="/" />} />
            <Route path="/add-worker" element={user && (userRole === 'worker' || userRole === 'admin') ? <AddWorker /> : <Navigate to="/" />} />
            <Route path="/edit-worker/:id" element={user ? <EditWorker /> : <Navigate to="/" />} />
            <Route path="/worker/:id" element={user ? <WorkerDetails /> : <Navigate to="/signup" />} />
            <Route path="/profile" element={user ? <Profile /> : <Navigate to="/signup" />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/about" element={<About />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </div>
        <Footer />
      </div>
    </BrowserRouter>
  );
}
export default App;